// @ts-check

/**
 * Renders the contact section as a minimal centered coda:
 * large serif CTA, primary email, one row of social links.
 */
export class ContactSection {
  /**
   * @param {HTMLElement} container
   * @param {Object} data
   */
  constructor(container, data) {
    this.container = container;
    this.data = data;
    this.render();
  }

  render() {
    const social = this.data.social ?? {};
    const links = Object.entries(social)
      .filter(([key]) => key !== 'email')
      .map(([key, url]) => {
        const label = key.charAt(0).toUpperCase() + key.slice(1);
        return `<a class="contact-social" href="${url}" target="_blank" rel="noopener noreferrer">${label}</a>`;
      })
      .join('<span class="contact-social-sep" aria-hidden="true">·</span>');

    this.container.innerHTML = `
      <div class="contact-minimal">
        <p class="contact-kicker">Commission · Collaboration</p>
        <p class="contact-big">一起创作</p>
        <p class="contact-big-en">Let's Create Together</p>
        <a class="contact-email" href="mailto:${social.email ?? 'hello@castinexile.com'}">${social.email ?? 'hello@castinexile.com'}</a>
        <div class="contact-socials">${links}</div>
      </div>
    `;
  }
}
